import { useMutation } from 'react-query'
import type { Response } from '@axios/types'
import { getAxiosInstance  } from '@axios/index'
import { AppState } from '@storage/interfaces/types'
import { queryKeys } from './reactQuery/queryKeys'


// export async function getListPayments(
//     appState: any,
//     userData: any
// ): Promise<Response> {
//     const { data } = await getAxiosInstance(appState).get(`/payments/recurrent/${userData.rut}` )
//     return data.paymentsRecurrent.paymentsRecurrentInfo
// }
  
// export function useGetListPayments(appState: any , userData: any ) {
//     const responseQuery: any = useQuery<any>({
//       queryKey: [ queryKeys.paymentsRecurrentData ] ,
//       queryFn: () => getListPayments( appState , userData )
//     }) 
//     return responseQuery
// }

export async function getListPayments(
    { appState , params } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).get(`/payments/recurrent/${params.rutTEMP}` )
    return data.paymentsRecurrent.paymentsRecurrentInfo
}

export const useGetListPayments = () => useMutation({
    mutationKey: queryKeys.paymentsRecurrentData,
    mutationFn: async (params: any & { appState: AppState }): Promise<any> => getListPayments(params)
})


export async function getListProductsInPayment(
    { appState , params } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).get(`/payments/recurrent/card/${params.idOneClick}/user/${params.rutTEMP}` )
    return data.paymentsRecurrent.paymentsRecurrentInfo
}

export const useGetListProductsInPayments = () => useMutation({
    mutationKey: queryKeys.paymentsMethodListAssociated,
    mutationFn: async (params: any & { appState: AppState }): Promise<any> => getListProductsInPayment(params)
})


export async function getPolicyAvaible(
    { appState , params } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).get(`/payments/policy/${params.rutTEMP}` )
    return data.paymentPolicyResponse
}

export const useGetPolicyAvaible = () => useMutation({
    mutationKey: queryKeys.paymentsPolicyAvaible,
    mutationFn: async (params: any & { appState: AppState }): Promise<any> => getPolicyAvaible(params)
})




export async function postAssociatePayment(
    { appState , dataTemp } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).post(`/payments/recurrent?source=SOAP` , dataTemp )
    return data
}

export const usePostAssociatePayment =
() => 
useMutation( {
    mutationKey: queryKeys.paymentsAssociateProduct ,
    mutationFn:  async ( params: any & { appState: AppState }): Promise<any> => postAssociatePayment( params )
} )

export async function postDeletePayment(
    { appState , dataTemp } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).delete(`/payments/methods/${dataTemp}`)
    return data
}

export const usePostDeletePayment =
() => 
useMutation( {
    mutationKey: queryKeys.paymentsMethodDelete ,
    mutationFn:  async ( params: any & { appState: AppState }): Promise<any> => postDeletePayment( params )
} )


export async function postAssociateAnotherMethod(
    { appState , dataTemp } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).post(`/payments/methods/change` , dataTemp )
    return data
}

export const usePostAssociateAnotherMethod =
() => 
useMutation( {
    mutationKey: queryKeys.paymentsAssociateAnotherMethod ,
    mutationFn:  async ( params: any & { appState: AppState }): Promise<any> => postAssociateAnotherMethod( params )
} )

export async function postRegisterMethod(
    { appState , params } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).post(`/payments/methods/register` , params )
    return data
}

export const usePostRegisterMethod =
() => 
useMutation( {
    mutationKey: queryKeys.paymentsMethodRegister ,
    mutationFn:  async ( params: any & { appState: AppState }): Promise<any> => postRegisterMethod( params )
} )

export async function postPaymentsNotification(
    { appState , params } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).post(`/payments/notification` , params )
    return data
}

export const usePostPaymentsNotification =
() => 
useMutation( {
    mutationKey: queryKeys.paymentsNotification ,
    mutationFn:  async ( params: any & { appState: AppState }): Promise<any> => {
        return postPaymentsNotification( params )
    }
} )


export async function postKillSession(
    { appState , params } : any
): Promise<Response> {
    const { data } = await getAxiosInstance(appState).post(`/payments/pip/token/kill` , params )
    return data
}

export const usePostKillSession =
() => 
useMutation( {
    mutationKey: queryKeys.paymentsKillSession ,
    mutationFn:  async ( params: any & { appState: AppState }): Promise<any> => {
        return postKillSession( params )
    }
} )
